import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { Toaster } from "./components/ui/sonner";

// Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import DashboardPage from "./pages/DashboardPage";
import CalendarPage from "./pages/CalendarPage";
import SchoolTrackerPage from "./pages/SchoolTrackerPage";
import MealPlannerPage from "./pages/MealPlannerPage";
import GroceryListPage from "./pages/GroceryListPage";
import RoutinesPage from "./pages/RoutinesPage";
import AppointmentsPage from "./pages/AppointmentsPage";
import HouseholdTasksPage from "./pages/HouseholdTasksPage";
import HandoffBoardPage from "./pages/HandoffBoardPage";
import BrainDumpPage from "./pages/BrainDumpPage";
import WeeklyResetPage from "./pages/WeeklyResetPage";
import WhatsAppConnectPage from "./pages/WhatsAppConnectPage";
import FamilyRolesPage from "./pages/FamilyRolesPage";
import WellnessPage from "./pages/WellnessPage";
import LoadMapPage from "./pages/LoadMapPage";

// Layout
import AppLayout from "./components/layout/AppLayout";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-nurture-cream flex items-center justify-center">
        <div className="animate-pulse text-nurture-terracotta text-xl font-heading">
          Loading...
        </div>
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen bg-nurture-cream flex items-center justify-center">
        <div className="animate-pulse text-nurture-terracotta text-xl font-heading">
          Loading...
        </div>
      </div>
    );
  }
  
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      } />
      <Route path="/register" element={
        <PublicRoute>
          <RegisterPage />
        </PublicRoute>
      } />
      <Route path="/" element={
        <ProtectedRoute>
          <AppLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        <Route path="school" element={<SchoolTrackerPage />} />
        <Route path="meals" element={<MealPlannerPage />} />
        <Route path="groceries" element={<GroceryListPage />} />
        <Route path="routines" element={<RoutinesPage />} />
        <Route path="appointments" element={<AppointmentsPage />} />
        <Route path="tasks" element={<HouseholdTasksPage />} />
        <Route path="handoff" element={<HandoffBoardPage />} />
        <Route path="brain-dump" element={<BrainDumpPage />} />
        <Route path="weekly-reset" element={<WeeklyResetPage />} />
        <Route path="whatsapp" element={<WhatsAppConnectPage />} />
        <Route path="family-roles" element={<FamilyRolesPage />} />
        <Route path="wellness" element={<WellnessPage />} />
        <Route path="load-map" element={<LoadMapPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
